import React, { useEffect } from 'react';
import styled from 'styled-components';
import { get } from 'lodash-es';
import moment from 'moment';
import {
  message,
  Heading4,
  DoconModal,
  DoconModalContent,
} from '@docon/docon-ui-library';
import { deleteAppointment, updateAppointmentState } from 'redux/reducer/appointment';
import { useDispatch, useSelector } from 'react-redux';
import { cleverTapAnl } from 'utilities';
import { getTimeFromMinutes } from 'utils';

interface IProps {
  isOpen: boolean;
  appointment: any;
  onClose: (x: any) => void;
}

const Modal = styled<any>(DoconModal)`
  max-width: 300px;
  border-radius: 10px;

  ${DoconModalContent} {
    text-align: center;
  }
`;

const CancelAppointment = ({
  isOpen,
  appointment,
  onClose,
}: IProps) => {
  const { isCancelingAppointment, cancelingAppointmentError } = useSelector(state => state.appointment);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      if (cancelingAppointmentError)
        dispatch(updateAppointmentState({ cancelingAppointmentError: '' }));
    };
  }, []);

  useEffect(() => {
    if (cancelingAppointmentError) {
      message.error(cancelingAppointmentError);
      onClose({});
    }
  }, [cancelingAppointmentError]);

  function handleOkClick() {
    const duration = moment.duration(moment(appointment.appointmentDisplayTime).diff(moment()));
    cleverTapAnl.event({
      event_name: 'appointment_cancel',
      event: {
        page_name: 'appointment_details',
        doctor_id: get(appointment, 'doctordetails.doctorID', ''),
        teleconsult_id: get(appointment, 'teleConsultSessionObject.id', null),
        appointment_id: appointment.appointmentID,
        appointment_date: moment(appointment.appointmentDate).format('YYYY-MM-DD'),
        appointment_status: appointment.status,
        slot_type: appointment.isTeleConsult ? 'video' : 'physical',
        slot_time: getTimeFromMinutes(appointment.appointmentTime),
        appointment_help_sub_reason: '',
        transaction_amount: get(appointment, 'teleConsultSessionObject.pricing_details.total', 0),
        cancel_time_to_appointment: Math.floor(duration.asMinutes()),
      },
    });
    dispatch(deleteAppointment(appointment));
  }

  return (
    <Modal
      isOpen={isOpen}
      centered
      hideCrossIcon
      isLoading={isCancelingAppointment}
      cancelText='No'
      okText='Yes'
      onOkClick={handleOkClick}
      onClose={onClose}
    >
      <Heading4 fontWeight={700} title={'Are you sure about this?'} />
    </Modal>
  );
};

export default CancelAppointment;